module.exports = __webpack_public_path__ + "static/media/bigquery-logo.7b205d74.svg";